import store from './index';
export var dispatchShowSnack = function dispatchShowSnack(msg) {
  return store.dispatch('snacks/showSnack', msg);
};
export var dispatchSignIn = function dispatchSignIn(me) {
  return store.dispatch('user/signIn', me);
};
export var dispatchSignOut = function dispatchSignOut() {
  return store.dispatch('user/signOut');
};
export var dispatchStorePage = function dispatchStorePage(page) {
  return store.dispatch('page/storePage', page);
};
export var dispatchClearPage = function dispatchClearPage(routeName) {
  return store.dispatch('page/clearPage', routeName);
};
export var dispatchUpdateIfNewOrders = function dispatchUpdateIfNewOrders(obj) {
  return store.dispatch('snacks/updateIfNewOrders', obj);
};